import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationLegalViewTypesPresenter } from "../../presenter/OrganisationLegalViewTypesPresenter";
import OrganisationLegalViewTypeGrid from "../components/OrganisationLegalViewTypeGrid";

export interface Props extends PageProps {}
export interface State extends IOrganisationLegalViewTypesPresenter {}

export default class OrganisationLegalViewTypesPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      onChangeAddElementsModalVisible,
      organisationLegalViewTypes,
      organisationId,
      addLegalViewTypeToOrganisation,
      onChangeAddTypesToOrganisationModalVisible,
      setOrganisationLegalViewTypeData,
      legalViewTypes,
      assignTypesToOrganisationModalVisible,
      modalVisible,
      currentLegalViewTypeId,
      organisationIndexCategories,
      legalViewTypeIndexCategories,
      addLegalViewTypeIndexCategories,
      removeDocumentLegalType
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        <Spin spinning={this.state.loaders.organisationLegalViewType}>
          <OrganisationLegalViewTypeGrid
            removeDocumentLegalType={removeDocumentLegalType}
            addLegalViewTypeIndexCategories={addLegalViewTypeIndexCategories}
            organisationLegalViewTypes={organisationLegalViewTypes}
            organisationId={organisationId}
            translate={translate}
            currentLegalViewTypeId={currentLegalViewTypeId}
            modalVisible={modalVisible}
            legalViewTypeIndexCategories={legalViewTypeIndexCategories}
            organisationIndexCategories={organisationIndexCategories}
            onChangeAddElementsModalVisible={onChangeAddElementsModalVisible}
            addLegalViewTypeToOrganisation={addLegalViewTypeToOrganisation}
            onChangeAddTypesToOrganisationModalVisible={
              onChangeAddTypesToOrganisationModalVisible
            }
            assignTypesToOrganisationModalVisible={
              assignTypesToOrganisationModalVisible
            }
            setOrganisationLegalViewTypeData={setOrganisationLegalViewTypeData}
            legalViewTypes={legalViewTypes}
          />
        </Spin>
      </Page>
    );
  }
}
